import SibApiV3Sdk from 'sib-api-v3-sdk';
import Vue from "vue";

let defaultClient = SibApiV3Sdk.ApiClient.instance;

// Configure API key authorization: api-key
let apiKey = defaultClient.authentications['api-key'];
apiKey.apiKey = process.env.VUE_APP_SIB_API_KEY;

// Configure API key authorization: partner-key
let partnerKey = defaultClient.authentications['partner-key'];
partnerKey.apiKey = process.env.VUE_APP_SIB_API_KEY;

class SIBService {
  getAccount() {
    let api = new SibApiV3Sdk.AccountApi();

    return api.getAccount();
  }

  canSendMessage() {
    return process.env.VUE_APP_SIB_API_KEY ? true : false;
  }

  async createContact(user, listIds=[]) {
    Vue.$log.info('SIB: Creating user: ', user);
    if (!this.canSendMessage() || user.email.includes('@ludimos.com')) {
      return;
    }
    let apiInstance = new SibApiV3Sdk.ContactsApi();
    var identifier = user.email;
    let contact; 
    try {
      Vue.$log.info('Uploading: ', user);
      contact = await apiInstance.getContactInfo(identifier)
    } catch (error) {
      Vue.$log.error(error)
    }

    if (contact && contact.statistics){
      if (listIds.length){
        Vue.$log.info('updating: ', user);
        await this.updateContact(user, listIds, []);
      }
      return contact;
    }

    let createContact = new SibApiV3Sdk.CreateContact();
    createContact.email = user.email;
    createContact.attributes = { FIRSTNAME: 'Ludimos', LASTNAME: 'user' };
    createContact.emailBlacklisted = false;
    createContact.tags = ['CREATE_CONTACT', process.env.NODE_ENV];
    if (listIds.length){
      createContact.listIds = listIds;
    }
    const resp = await apiInstance.createContact(createContact);
    if (!resp.id) {
      Vue.$log.error(`Something went wrong while creating new account at sendinblue ${user.email}`);
    }

    return resp;
  }
  async updateContact(user, listIds = [], unlinkListIds = []) {
    if (!this.canSendMessage() || user.email.includes('@ludimos.com')) {
      return;
    }
    let apiInstance = new SibApiV3Sdk.ContactsApi();
    let updateContact = new SibApiV3Sdk.UpdateContact();
    updateContact.attributes = { FIRSTNAME: 'Ludimos', LASTNAME: 'user' };
    updateContact.tags = ['UPDATE_CONTACT', process.env.NODE_ENV];

    if (listIds.length) {
      updateContact.listIds = listIds;
    }
    if (unlinkListIds.length) {
      updateContact.unlinkListIds = unlinkListIds;
    }
    const resp = await apiInstance.updateContact(user.email, updateContact);
    if (resp) {
      Vue.$log.error(`Something went wrong while updating contact at sendinblue ${user.email}`);
    }

    return resp;
  }

  async addContactsToList(listId, users) {
    if (!this.canSendMessage()) {
      return;
    }
    try {
      await users.map(async member => {
        const r = await this.createContact(member.user, [listId])
        return r;
      })
      
    } catch (error) {
      Vue.$log.error(`Something went wrong while adding users to list ${listId} `);
      return false;
    }
   
  }
}
export default new SIBService();
